import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
function PageNum1() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="firstPage">
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-6 col-sm-12">
            <div className="landing gap-4 d-flex align-items-center align-content-center flex-wrap justify-content-start flex-row">
              <h1>وجهتك المتكاملة للمركبات الكهربائية في مصر!</h1>
              <p>
                وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من
                التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان
                وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من
                الملاحظات او الانتقادات للتصميم الاساسي.
              </p>
              <div className="fBottons d-flex text-center gap-3 mt-2 ms-2 me-2">
                <button
                  className="btn btn-success text-black rounded-4"
                  onClick={() => handleNavigate("/Page2")}
                >
                  <i className="fa-solid fa-car" /> اشتري
                </button>
                <button
                  className="btn btn-light rounded-4"
                  onClick={() => handleNavigate("/Page4")}
                >
                  <img src="/img/Frame.png" alt="icon" /> اعرض للبيع
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNum1;
